import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

// Default Chart.js configuration
export const defaultChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: 'index',
    intersect: false,
  },
  plugins: {
    legend: {
      position: 'top',
      labels: {
        usePointStyle: true,
        padding: 15,
        font: {
          size: 12,
          family: "'Inter', sans-serif"
        }
      }
    },
    tooltip: {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      padding: 12,
      titleFont: {
        size: 14,
        weight: 'bold'
      },
      bodyFont: {
        size: 13
      },
      borderColor: 'rgba(255, 255, 255, 0.1)',
      borderWidth: 1,
      displayColors: true,
      callbacks: {
        label: function(context) {
          let label = context.dataset.label || '';
          if (label) {
            label += ': ';
          }
          if (context.parsed.y !== null) {
            label += context.parsed.y.toFixed(2);
          }
          return label;
        }
      }
    }
  },
  scales: {
    x: {
      grid: {
        display: false
      },
      ticks: {
        font: {
          size: 11
        },
        maxRotation: 45,
        minRotation: 0
      }
    },
    y: {
      beginAtZero: false,
      grid: {
        color: 'rgba(0, 0, 0, 0.05)'
      },
      ticks: {
        font: {
          size: 11
        }
      }
    }
  }
};

// Metric color mapping for consistency across charts
export const metricColors = {
  jump_height_cm: {
    border: 'rgb(59, 130, 246)',
    background: 'rgba(59, 130, 246, 0.1)'
  },
  rotation_speed_rev_s: {
    border: 'rgb(16, 185, 129)',
    background: 'rgba(16, 185, 129, 0.1)'
  },
  rotation_count: {
    border: 'rgb(139, 92, 246)',
    background: 'rgba(139, 92, 246, 0.1)'
  },
  takeoff_velocity_m_s: {
    border: 'rgb(245, 158, 11)',
    background: 'rgba(245, 158, 11, 0.1)'
  },
  landing_stability_score: {
    border: 'rgb(236, 72, 153)',
    background: 'rgba(236, 72, 153, 0.1)'
  },
  isu_score: {
    border: 'rgb(75, 0, 130)',      // Dark purple (Indigo)
    background: 'rgba(75, 0, 130, 0.1)'
  },
  air_time_s: {
    border: 'rgb(14, 165, 233)',
    background: 'rgba(14, 165, 233, 0.1)'
  }
};

// Format metric names for display
export const formatMetricName = (metricKey) => {
  // Handle undefined, null, or non-string values
  if (!metricKey) {
    return 'Unknown Metric';
  }
  if (typeof metricKey !== 'string') {
    metricKey = String(metricKey);
  }

  const nameMap = {
    jump_height_cm: 'Jump Height (cm)',
    rotation_speed_rev_s: 'Rotation Speed (rev/s)',
    rotation_count: 'Rotation Count',
    takeoff_velocity_m_s: 'Takeoff Velocity (m/s)',
    landing_stability_score: 'Landing Stability',
    isu_score: 'ISU Score',
    air_time_s: 'Air Time (s)'
  };
  return nameMap[metricKey] || metricKey.replace(/_/g, ' ');
};

// Get color for a metric
export const getMetricColor = (metricKey) => {
  return metricColors[metricKey] || {
    border: 'rgb(107, 114, 128)',
    background: 'rgba(107, 114, 128, 0.1)'
  };
};
